import { useCallback } from "react";
import { useLocation } from "react-router";
import { IconButton, Link, List, ListItem, useTheme } from "@mui/material";

import Link_icon from "@/assets/icons/contacts/link.svg?react";
import { socials } from "@/utils/staticData/contacts";
import { getLinkButtonStyles, getSocialsStyles } from "./styles";

const Socials = () => {
  const theme = useTheme();
  const location = useLocation();

  const copyToClipboard = useCallback(() => {
    const domain = window.location.origin;
    const path = location.pathname;

    navigator.clipboard
      .writeText(`${domain}${path}`)
      .then(() => {
        console.log("link copied");
      })
      .catch((err) => {
        console.error("copy error", err);
      });
  }, [location.pathname]);

  return (
    <List sx={{ display: "flex", gap: 1.5 }} disablePadding>
      {socials.map(({ Icon, href, label }) => (
        <ListItem key={href} sx={{ maxWidth: "fit-content" }} disablePadding>
          <Link
            target="_blank"
            rel="noreferrer"
            aria-label={label}
            href={href}
            color={theme.palette.grey[600]}
            sx={getSocialsStyles(theme)}
          >
            <Icon />
          </Link>
        </ListItem>
      ))}
      <ListItem sx={{ maxWidth: "fit-content" }} disablePadding>
        <IconButton onClick={copyToClipboard} sx={getLinkButtonStyles}>
          <Link_icon />
        </IconButton>
      </ListItem>
    </List>
  );
};

export default Socials;
